const sanitizeJsonSchema = (jsonSchema?: string): string => {
  const scriptStart = /<script[\s\S]*?>/gi;
  const scriptEnd = /<\/script>/gi;
  const whiteSpaceLineBreaks = /(\r\n|\n|\r)/gm;

  return (jsonSchema || "").replaceAll(scriptStart, "").replaceAll(scriptEnd, "").replace(whiteSpaceLineBreaks, "");
};

export { sanitizeJsonSchema };
